import { CategoryType } from './constants';
import { IAddressInput, IAddressUsage, IContactPhone, IDigitalAddress } from './contact'
import { IValueListLight } from './valuelist';
import { IPosition } from './position';

export interface ICategory {
  id: number;
  categoryName: string;
  type?: CategoryType;
  displayOrder: number;
}

export interface IOrg {
  id: number;
  orgName: string;
  createDate: string;
  orgAcronym: string; // this property is used for the hierarchy tree, but originates from the same field as IOrgDetails.orgAcronym
  parentOrg: IOrgLight;
  parentOrgId: number;
  hasChild: boolean;
  path: string[];
  details: IOrgDetails;
  relationships: IOrgRelationship[];
  addressUsages: IAddressUsage[];
  digitalAddresses: IDigitalAddress[];
  contactPhones: IContactPhone[];
  positions: IPosition[];
  roles: IPosition[];
  suppress: boolean;
  sequence: number;
  clonedFromOrgId: number;
  sharedToOrgIds: string;
}

export function isCategory(item: ICategory | IOrg | undefined): item is ICategory {
  if (item == undefined) return false
  let ret = (item as ICategory).categoryName !== undefined
  return ret
}

export function isTopOrg(item: ICategory | IOrg | undefined): item is IOrg {
  if (!item || isCategory(item)) return false;
  return item.parentOrg == null && item.parentOrgId == null;
}

export function getOrgName(item: ICategory | IOrg | undefined): string | undefined {
  return isCategory(item) ? item.categoryName : item?.orgName
}

export interface IOrgLight {
  id: number;
  orgName: string;
  startDate: string;
}

export interface IOrgDetails {
  orgAcronym: string;
  category: ICategory;
  orgType: IValueListLight;
  orgPrefix: IValueListLight;
  description: string;
  shareLinkId: number;
  frenchName: string;
  frenchNameTranslated: boolean;
  frenchDescription: string
  frenchDescriptionTranslated: boolean
}

export interface IOrgRelationship {
  relationshipId: number;
  destOrgId: number;
  destOrgName: string;
  destCloned: boolean;
  destParentOrgId: number;
  relationshipType: IValueListLight;
  positive: boolean;
  createTimestamp: string;
}

export interface ICategoriesResponse {
  categories: ICategory[];
}

export interface IGlobalCategoriesResponse {
  globalCategories: ICategory[];
}

export interface IRootOrgsResponse {
  rootOrgs: IOrg[];
}

export interface IGlobalRootOrgsResponse {
  globalRootOrgs: IOrg[];
}

export interface IAllRootOrgsResponse {
  allRootOrgs: IOrgLight[];
}

export interface IChildOrgsResponse {
  childOrgs: IOrg[];
}

export interface IOrgResponse {
  org: IOrg;
}

export interface IOrgPathResponse {
  orgPath: string[]
}

export interface IOrgPathIdResponse {
  orgPathId: number[]
}

export interface IOrgInput {
  orgName: string;
  orgTypeId: number;
  orgPrefixId?: number;
  orgAcronym?: string;
  description?: string;
  address?: IAddressInput;
  frenchName?: string;
  frenchNameTranslated?: boolean;
  frenchDescription?: string
  frenchDescriptionTranslated?: boolean
}

export interface ISearchOrgResult {
  id: number;
  orgName: string;
  addressUsages: IAddressUsage[];
  contactPhones: IContactPhone[];
  desc: string;
  restricted: boolean;
}

export interface ISearchOrgResponse {
  searchOrg: {
    orgs: ISearchOrgResult[];
    message: string;
  }
}

export interface ISearchOrgInput {
  orgId: number;
  orgName?: string;
  addressFullTxt?: string;
  contactNumber?: string;
  unitDescription?: string;
}

export interface ICreateRelationshipInput {
  orgId: number;
  otherOrgId: number;
  relTypeId: number;
  childOrgIds: number[];
  parentCategory: boolean;
  relationshipIds: number [];
}
